module.exports = __webpack_public_path__ + "static/WW_1920x900-mobile.3c0e043e.jpg";